import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import HomePage from './components/Pages/HomePage/HomePage';
import Layout from './components/Layout';
import EditCourse from './components/Pages/Courses/EditCourse/EditCourse';
import CoursesPage from './components/Pages/Courses/CoursesPage';
import NewCourse from './components/Pages/Courses/NewCourse/NewCourse';
import LearningTracking from './components/Pages/LearningTracking/LearningTracking'
import LearningTrackingMain from './components/Pages/LearningTracking/LearningTrackingMain'
import LearningTrackingAssessments from './components/Pages/LearningTracking/LearningTrackingAssessments';
import StudentTrackingPage from './components/Pages/LearningTracking/StudentTracking/StudentTrackingPage'
import StudentsLayoutPage from './components/Pages/LearningTracking/StudentsLayout/StudentLayoutPage';
import Lesson from './components/Pages/LearningTracking/Lesson/Lesson'
import Submission from './components/Pages/Submission/Submission';
import * as PathRouter from './models/PathRoute'
import ProjectContainer from './components/Pages/Projects/ProjectContainer';
import EditLesson from './components/Pages/Lesson/EditLesson';
import NewAssessment from './components/Pages/Assessments/NewAssessment/NewAssessment';
import Curriculums from './components/Pages/Curriculums/Curriculums';
import CurriculumPage from './components/Pages/Curriculums/CurriculumPage';
import CurriculumMenu from './components/Pages/Curriculums/CurriculumMenu';
import ProjectEditor from './components/Pages/Project/ProjectEditor';
import TrainingRoom from './components/Pages/TrainingRoom/TrainingRoom';
import LoginErrorPage from './components/lms-shared/errors/LoginErrorPage';
import IdeRunnerWarrper from './components/lms-shared/IdeRunnerWarrper/IdeRunnerWarrper';
import ContentBankWrapper from './components/Pages/ContentBank/ContentBankWrapper';
import DirectLessonViewer from './components/Pages/MaterialLibrary/DirectLessonViewer';
import ProjectViewer from './components/Pages/MaterialLibrary/ProjectViewer/ProjectViewer';
import DirectLessonProject from './components/Pages/MaterialLibrary/DirectLessonProject';
import Connect from './components/Pages/Connect';
import Home from './components/Pages/Admin/Home';
import AdminLayout from './components/Pages/Admin/AdminLayout';
import DisciplinesPage from './components/Pages/Admin/Disciplines/DisciplinesPage';
import DisciplineEdit from './components/Pages/Admin/Disciplines/DisciplineEdit';
import Posts from './components/Pages/Admin/Posts/Posts';
import Messages from './components/Pages/Admin/Messages/Messages';
import MessagesPage from './components/Pages/Admin/Messages/MessagesPage';
import Guide from './components/Pages/Admin/Guide/Guide';
import ProjectGuide from './components/Pages/Admin/Guide/ProjectGuide';
import StudentBanner from './components/Pages/Admin/StudentBanner/StudentBanner';
import TeacherBanner from './components/Pages/Admin/TeacherBanner/TeacherBanner';
import TrainingsPage from './components/Pages/Admin/Trainings/TrainingsPage';
import { DynamicMessageTypeEnum } from './components/lms-shared/models/DynamicMessageTypeEnum';
import DynamicMessage from './components/lms-shared/UI/Popups/DynamicMessage/DynamicMessage';
import TeamsPage from './components/Pages/LearningTracking/Teams/TeamsPage';
import AddNationalStudygroup from './components/Pages/Admin/AddNationalStudygroup/AddNationalStudygroup';
import { getGeneral } from './store/general-actions';
import { initTexts } from './store/translate-actions';
import { fetchYears } from './store/studyYears-actions';
import useAnalytics from './components/lms-shared/hooks/useAnalytics';

function App() {

  const texts = useSelector((state) => state.translate.texts);
  const { externalId, lastName, firstName } = useSelector((state) => state.auth.user);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const uiData = useSelector((state) => state.general.uiData);
  const dispatch = useDispatch()

  const [dataAr, setDataAr] = useState();
  const [dataHe, setDataHe] = useState();
  const [dataEn, setDataEn] = useState();

  useEffect(() => {
    dispatch(getGeneral())
  }, [])

  useEffect(() => {
    dispatch(initTexts());
    if (uiData) {
      dispatch(fetchYears(uiData));
    }
  }, [dispatch, uiData]);

  useEffect(() => {
    if (externalId) {
      if (uiData.apm && !uiData.apm.unable) {
        window.elasticApm.setUserContext({ id: externalId, username: `${firstName} ${lastName}` })
      }
    }
  }, [externalId, uiData])

  useAnalytics()

  // useEffect(() => {
  //   if (dataAr && dataHe && dataEn) {
  //     console.log('dataAr', Object.keys(dataAr).length)
  //     console.log('dataHe', Object.keys(dataHe).length)
  //     console.log('dataEn', Object.keys(dataEn).length)
  //     let obj = {}
  //     Object.keys(dataHe).forEach(x => {
  //       if (!dataAr.hasOwnProperty(x)) {
  //         obj[x] = dataHe[x];
  //       }
  //     })
  //     console.log('missing ar tarnslate', obj)

  //     let obj2 = {}
  //     Object.keys(dataAr).forEach(x => {
  //       if (!dataHe.hasOwnProperty(x)) {
  //         obj2[x] = dataAr[x];
  //       }
  //     })
  //     console.log('missing he tarnslate', obj2)

  //     let obj3 = {}
  //     Object.keys(dataHe).forEach(x => {
  //       if (!dataEn.hasOwnProperty(x)) {
  //         obj3[x] = dataHe[x];
  //       }
  //     })
  //     console.log('missing en tarnslate', obj3)
  //   }
  // }, [dataAr, dataHe, dataEn])

  return (
    (() =>
            <Routes >
              <Route path=":applictionName">
                <Route path="projectRunner/:postId" element={<IdeRunnerWarrper></IdeRunnerWarrper>}></Route>
                <Route path="error" element={<LoginErrorPage />} ></Route>
                {/* <Route path="trytofixerror" element={<LoginErrorPage tryAgain={true}/>} ></Route> */}
                <Route element={<Layout />}>
                  {isAuthenticated ? <>
                    <Route index element={<HomePage />} />
                    <Route path="projectCode">
                      <Route index element={<ProjectViewer />}></Route>
                      <Route path=":postId" element={<ProjectViewer />}></Route>
                    </Route>
                    <Route path={`${PathRouter.CONNECT}/:courseId/:studyGroupId`} element={<Connect />}></Route>
                    <Route path={PathRouter.HOME} element={<HomePage />}></Route>
                    <Route path={PathRouter.COURSES} >
                      <Route index element={<CoursesPage title={texts.dashboardMyCourses} getPassUrlFromCourse={(id) => `${id}`} />}></Route>
                      <Route path=':id' element={<EditCourse />}></Route>
                      <Route path={PathRouter.NEW} element={<NewCourse />}></Route>
                    </Route>
                    <Route path={PathRouter.ADMIN} >
                      <Route index element={<Home></Home>}></Route>
                      <Route path='' element={<AdminLayout></AdminLayout>}>
                        <Route path={PathRouter.DISCIPILINES} >
                          <Route index element={<DisciplinesPage />}></Route>
                          <Route path={PathRouter.NEW} element={<DisciplineEdit />}></Route>
                          <Route path=':disciplinId' element={<DisciplineEdit />}></Route>
                          <Route path=':disciplinId/:studyGroupId' element={<AddNationalStudygroup />}></Route>
                        </Route>
                        <Route path={PathRouter.POSTS} element={<Posts></Posts>}></Route>
                        <Route path={PathRouter.MESSAGES} element={<MessagesPage></MessagesPage>}></Route>
                        <Route path={PathRouter.STUDENT_BANNER} element={<StudentBanner></StudentBanner>}></Route>
                        <Route path={PathRouter.TEACHER_BANNER} element={<TeacherBanner></TeacherBanner>}></Route>
                        <Route path={PathRouter.TRANINGS} element={<TrainingsPage></TrainingsPage>}></Route>
                        <Route path={PathRouter.GUIDE} element={<Guide></Guide>}></Route>
                        <Route path={`${PathRouter.SUBMISSION}/:submissionId`} element={<ProjectGuide></ProjectGuide>}></Route>
                      </Route>
                    </Route>
                    {/* <Route path={PathRouter.PROFESSIONS} >
                    <Route index element={<CoursesPage title={texts.dashboardMyCourses} getPassUrlFromCourse={(id) => `${id}`} />}></Route>
                    <Route path=':id' element={<EditCourse isProfession={true} />}></Route>
                    <Route path={PathRouter.NEW} element={<NewCourse />}></Route>
                  </Route> */}
                    <Route path={PathRouter.LESSONS} >
                      <Route path={PathRouter.NEW} element={<EditLesson />}></Route>
                      <Route path={':guid'} element={<EditLesson />}></Route>
                    </Route>
                    <Route path={PathRouter.ASSESSMENTS} >
                      <Route path={PathRouter.NEW} element={<NewAssessment />}></Route>
                      <Route path={':guid'} element={<NewAssessment />}></Route>
                    </Route>
                    <Route path={PathRouter.LEARNING_TRACKING} >
                      <Route index element={<CoursesPage title={texts.dashboardLearningMonitoring} getPassUrlFromCourse={(id) => `${id}/learningTrackingMain`} />}></Route>
                      <Route path=':id' >
                        <Route path={`${PathRouter.SUBMISSION}`} >
                          <Route path={`:submissionId`} element={<Submission />}></Route>
                        </Route>
                        <Route path='' element={<LearningTracking />}>
                          <Route path={`${PathRouter.LEARNING_TRACKING_MAIN}`} element={<LearningTrackingMain />}></Route>
                          <Route path={`${PathRouter.STUDENTS_LAYOUT}/:guid`} element={<StudentsLayoutPage />}></Route>
                          <Route path={`${PathRouter.ASSESSMENTS}/:guid`} element={<LearningTrackingAssessments />}></Route>
                          <Route path={`${PathRouter.STUDENT_TRACKING}/:guid`} element={<StudentTrackingPage />}></Route>
                          <Route path={`${PathRouter.LESSON}/:guid`} element={<Lesson />}></Route>
                          <Route path={`${PathRouter.TEAMS}/:guid`} element={<TeamsPage currentTab={1} />}>  </Route>
                          <Route path={`${PathRouter.TEAMS}/all`} element={<TeamsPage currentTab={0} />}>  </Route>
                        </Route>
                      </Route>
                      <Route path={`${PathRouter.PROJECT}/:id`} element={<ProjectContainer />}></Route>
                    </Route>
                    <Route path={PathRouter.CURRICULUMS} element={<Curriculums />}></Route>
                    <Route path={PathRouter.CURRICULUM} element={<CurriculumMenu />}>
                      <Route path={':guid'} element={<CurriculumPage />}></Route>
                    </Route>
                    <Route path={PathRouter.MATERIAL_LIBRARY} >
                      <Route index element={<ContentBankWrapper />} />
                    </Route>
                    <Route path={PathRouter.TRAINING_ROOM} >
                      <Route index element={<TrainingRoom />} />
                    </Route>
                    <Route path={`${PathRouter.PROJECT}/:projectId`} element={<ProjectEditor></ProjectEditor>}></Route>
                    <Route path={`${PathRouter.LESSON}/:postId`} element={<DirectLessonViewer></DirectLessonViewer>}></Route>
                    <Route path={`${PathRouter.CBLESSON}/:postId`} element={<DirectLessonViewer />}></Route>
                    <Route path={`${PathRouter.LESSONPROJECT}/:postId`} element={<DirectLessonProject></DirectLessonProject>}></Route>
                  </> : <><Route index element={<div></div>}></Route><Route path='*' element={<div></div>}></Route></>}
                </Route>
              </Route>
            </Routes>
    )()
  );
}

export default App;
// openapi-generator-cli generate -g javascript -i .\swagger3.json -o api-client
